"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDynamicMarginSide = exports.getDynamicMarginV = exports.getDynamicFontSize = exports.buildSizedMediaConfig = exports.calculateVideoRatio = exports.resetProFeatures = exports.hasProFeatures = void 0;
var media_config_1 = require("../interfaces/media-config");
exports.hasProFeatures = function (mediaConfig) {
    // Skip pro checks for how to video
    if (mediaConfig.isHowToVideo) {
        return false;
    }
    var features = [];
    // Check if watermark is on?
    if (hasNotWatermark(mediaConfig)) {
        features.push("hasNotWatermark");
    }
    // Check if it has a custom logo
    if (hasCustomLogo(mediaConfig)) {
        features.push("hasCustomLogo");
    }
    // Check if it has an aspect ratio
    if (hasAspectRatio(mediaConfig)) {
        features.push("hasAspectRatio");
    }
    // Check if it has a headline
    if (hasHeadline(mediaConfig)) {
        features.push("hasHeadline");
    }
    if (features.length) {
        return features;
    }
    return false;
};
var hasNotWatermark = function (_a) {
    var showWatermark = _a.showWatermark;
    return showWatermark === false;
};
var hasCustomLogo = function (_a) {
    var customLogo = _a.customLogo;
    return Boolean(customLogo === null || customLogo === void 0 ? void 0 : customLogo.url);
};
var hasAspectRatio = function (_a) {
    var aspectRatio = _a.aspectRatio;
    if (!aspectRatio) {
        return false;
    }
    return aspectRatio.ratio !== aspectRatio.originalRatio;
};
var hasHeadline = function (_a) {
    var headline = _a.headline;
    if (!headline) {
        return false;
    }
    return Boolean(headline.text);
};
exports.resetProFeatures = function (mediaConfig) {
    if (mediaConfig.aspectRatio) {
        return __assign(__assign({}, mediaConfig), { showWatermark: true, customLogo: undefined, headline: undefined, aspectRatio: __assign(__assign({}, mediaConfig.aspectRatio), { ratio: mediaConfig.aspectRatio.originalRatio }) });
    }
    return __assign(__assign({}, mediaConfig), { showWatermark: true, customLogo: undefined, headline: undefined, aspectRatio: undefined });
};
exports.calculateVideoRatio = function (videoHeight, videoWidth) {
    var videoRatio = videoWidth / videoHeight;
    var aspectRatio = Object.values(media_config_1.AspectRatio).find(function (ratio) {
        var _a = ratio.split(":"), w = _a[0], h = _a[1];
        if (!w || !h) {
            return false;
        }
        return +w / +h === videoRatio;
    });
    if (!aspectRatio) {
        return media_config_1.AspectRatio.Original;
    }
    return aspectRatio;
};
exports.buildSizedMediaConfig = function (config, _a) {
    var height = _a.height, width = _a.width;
    if (!height || !width) {
        return config;
    }
    var ratio = exports.calculateVideoRatio(height, width);
    var marginS = exports.getDynamicMarginSide(width);
    return __assign(__assign({}, config), { playResX: width, playResY: height, fontSize: exports.getDynamicFontSize(height), marginV: exports.getDynamicMarginV(height), marginL: marginS, marginR: marginS, aspectRatio: __assign(__assign(__assign({}, media_config_1.DEFAULT_ASPECT_RATIO_CONFIG), config.aspectRatio), { originalRatio: ratio, ratio: ratio }) });
};
exports.getDynamicFontSize = function (height) {
    if (!height) {
        return 72;
    }
    if (height <= 360) {
        return 24;
    }
    else if (height <= 576) {
        return 40;
    }
    else if (height <= 720) {
        return 48;
    }
    return 72;
};
exports.getDynamicMarginV = function (height) {
    if (!height) {
        return 100;
    }
    if (height <= 360) {
        return 40;
    }
    else if (height <= 576) {
        return 50;
    }
    else if (height <= 720) {
        return 80;
    }
    return 100;
};
exports.getDynamicMarginSide = function (width) {
    if (!width) {
        return 100;
    }
    if (width <= 576) {
        return 50;
    }
    return 100;
};
//# sourceMappingURL=utils.js.map